module.exports = __webpack_public_path__ + "r-v3/img/emoti-smile.87cdedd1.svg";